import { createColumnHelper, CellContext } from "@tanstack/react-table";
import React, { useState } from "react";
import Select from "react-select";
import IconInformeAuditoria from "../../../../assets/img/iconInformeAuditoria";
import IconPlanAuditoria from "../../../../assets/img/iconPlanAuditoria";
import { EnumEstadoAuditoria } from "../../../../entities/helper/EnumEstadoAuditoria";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import IAuditoria from "../../../../entities/IAuditoria";
import { ITipoAuditoria } from "../../../../entities/ITipoAuditoria";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI } from "../../../../helpers/httpHelper";
import { PathsAuditoria } from "../../../../helpers/pathDocumentsHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import {
  ROW_COUNT,
  API_AUDITORIA,
  API_AUDITORIA_GETALL_PLANESAUDITORIAS,
  API_ADMIN_TIPO_AUDITORIA,
  URL_SUPPORT,
  API_AUDITORIA_GETALL_HISTORICOPLANESAUDITORIA,
} from "../../../../helpers/variableHelper";
import AuditoriaService from "../../../../services/AuditoriaService";
import AdminLista from "../../../administration/AdminLista";
import DetalleAuditoria from "../DetalleAuditoria";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import { cognitoUserInfo } from "../../../../helpers/userHelper";
import Loading from "../../../../cross/Loading";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import { cParamsActiveOrderNombre } from "../../../../helpers/paramsHelper";

interface IPlanesProps {
  token: string;
  isHistorico: boolean;
  items?: Array<any>;
  loading?: boolean;
}
export default function Planes({ token, isHistorico, items, loading = true }: IPlanesProps) {
  const [showDetails, setShowDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(loading);

  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [comboTA, setComboTA] = useState<Array<ITipoAuditoria>>([]);
  const refTxtAnio = React.createRef<HTMLInputElement>();
  const refTxtFechaDesde = React.createRef<HTMLInputElement>();
  const refTxtFechaHasta = React.createRef<HTMLInputElement>();
  const [refComboTA, setValComboTA] = useState<IComboboxOption | null>(null);
  const [filtersState, setFiltersState] = useState<any>({});
  const [planSeleccionado, setPlanSeleccionado] = useState<IAuditoria | null>(null);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isDownloading, setIsDownloading] = useState(false);
  usePromiseEffect(async () => {
    setIsLoading(true);
    let currUser = await cognitoUserInfo();
    console.log(currentUser);
    setCurrentUser(currUser);

    try {
      const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre))
        .result.data;
      setComboTA(combo);

      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, []);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentArchivo = (value: any) => {
    return (
      <div>
        {value.row.original.ID_ESTADO >= EnumEstadoAuditoria.PlanListo && (
          <i
            className="bi bi-file-earmark-arrow-down-fill iconDescarga"
            title="Plan de auditoría"
            onClick={async () => {
              const path = PathsAuditoria.PlanAuditoriaPath(value.row.original.ID_PROGRAMA_AUDITORIA as number, value.row.original.ID as number);
              setIsDownloading(true);
              let flag = await AuditoriaService.GetContenidoArchivo(token, path);
              if (!flag) {
                await AuditoriaService.GenerarPDFPlan(token, value.row.original.ID as number);
                await AuditoriaService.GetContenidoArchivo(token, path);
              }
              setIsDownloading(false);
            }}></i>
        )}
        {value.row.original.ID_ESTADO >= EnumEstadoAuditoria.InformeListo && (
          <i
            className="bi bi-file-earmark-arrow-down-fill iconDescarga"
            title="Informe de auditoría"
            onClick={async () => {
              const path = PathsAuditoria.InformeAuditoriaPath(value.row.original.ID_PROGRAMA_AUDITORIA as number, value.row.original.ID as number);
              setIsDownloading(true);
              let flag = await AuditoriaService.GetContenidoArchivo(token, path);
              if (!flag) {
                await AuditoriaService.GenerarPDFInforme(token, value.row.original.ID as number);
                await AuditoriaService.GetContenidoArchivo(token, path);
              }
              setIsDownloading(false);
            }}></i>
        )}
      </div>
    );
  };

  const componentOpciones = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch  me-1"
          title="Ver Auditoría"
          onClick={() => {
            setShowDetails(true);
            setPlanSeleccionado(value.row.original);
          }}></i>
        {value.row.original.ID_ESTADO >= EnumEstadoAuditoria.AuditoriaAprobada && (
          <a href={`plan?id=${value.row.original.ID}${isHistorico ? "&isHistorico=1" : ""}`} className="text-decoration-none  me-1">
            <IconPlanAuditoria />
          </a>
        )}
        {value.row.original.ID_ESTADO >= EnumEstadoAuditoria.PlanListo && (
          <a href={`planInforme?id=${value.row.original.ID}`} className="text-decoration-none me-1">
            <IconInformeAuditoria />
          </a>
        )}
      </div>
    );
  };

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const closeDetailsPanel = () => {
    setShowDetails(false);
    setPlanSeleccionado(null);
  };
  const filter = (filters: Partial<IAuditoria>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = size;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = "ID";
      filters.ORIENTACION = "DESC";
    }
    filters.VICEPRESIDENCIA = filters.VICEPRESIDENCIA?.toString();
    filters.ANIO = refTxtAnio.current?.value;
    filters.FECHA_DESDE = refTxtFechaDesde.current?.value ? new Date(refTxtFechaDesde.current.value) : null;
    filters.FECHA_HASTA = refTxtFechaHasta.current?.value ? new Date(refTxtFechaHasta.current.value) : null;
    filters.TIPO_AUDITORIA = refComboTA?.label;
    setFiltersState(filters);
    getAPI(
      isHistorico ? `${API_AUDITORIA}${API_AUDITORIA_GETALL_HISTORICOPLANESAUDITORIA}` : `${API_AUDITORIA}${API_AUDITORIA_GETALL_PLANESAUDITORIAS}`,
      { Authorization: `Bearer ${token}` },
      filters
    )
      .then((result) => {
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const columnHelperMantIncCausa = createColumnHelper<IAuditoria>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Código Auditoría"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ESTADO, {
      id: "ESTADO_AUDITORIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Estado Auditoría"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "OPCIONES",
      cell: (
        //
        info: CellContext<IAuditoria, string>
      ) => componentOpciones(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      //hide: (!currentUser?.roles.IS_ADMIN && !currentUser?.roles.IS_ADMIN_AUDITORIA)
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "ARCHIVO",
      cell: (
        //
        info: CellContext<IAuditoria, string>
      ) => componentArchivo(info),
      header: () => component("Archivo"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.TIPO_AUDITORIA, {
      id: "TIPO_AUDITORIA_COLUMNA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Auditoría"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.OBJETIVO_ALCANCE_EXCLUSIONES, {
      id: "OBJETIVO_ALCANCE_EXCLUSIONES",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Objetivo Alcance y Exclusiones"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_DESDE, {
      id: "FECHA_DESDE_COLUMNA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Inicio"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA_COLUMNA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Término"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.AUDITOR_LIDER_DISPLAY || row.AUDITOR_LIDER, {
      id: "AUDITOR_LIDER",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Auditor Líder"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.AUDITORES_ACOMPANANTES_DISPLAY || row.AUDITORES_ACOMPANANTES, {
      id: "AUDITORES_ACOMPANANTES",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Auditores Acompañantes"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.RESPONSABLE_AREA_DISPLAY || row.RESPONSABLE_AREA, {
      id: "RESPONSABLE_AREA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Responsable Área a Auditar"),
      tipo: ITipo_Campo.text,
    } as any),
  ] as any;
  return (
    <div>
      {isDownloading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
      <div className="card bg-light border p-3 pt-2 mt-2">
        <button
          hidden={true}
          data-testid="test1"
          onClick={() => {
            paging(1);
            closeDetailsPanel();
          }}></button>
        <div className="row ajusteInput">
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label className="text-sm">Buscar año</label>
            <input ref={refTxtAnio} className="form-control form-control-sm" type="number" placeholder="Indique el año" />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label className="text-sm">{!isHistorico ? `Fecha inicio plan de auditoría (desde - hasta)` : `Fecha creación desde - hasta`}</label>
            <div className="d-flex">
              <input ref={refTxtFechaDesde} className="form-control form-control-sm w-50 me-2" type="date" placeholder="desde" />
              <input ref={refTxtFechaHasta} className="form-control form-control-sm w-50" type="date" placeholder="hasta" />
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0"></div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label>Tipo Auditoría</label>
            <Select
              options={
                comboTA.map((vcc) => ({
                  value: vcc.NOMBRE,
                  label: vcc.NOMBRE,
                })) as any
              }
              placeholder="Seleccione"
              value={refComboTA || ""}
              isClearable={true}
              onChange={async (e: any) => {
                setValComboTA(e);
              }}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
            <button
              type="button"
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                filter(filtersState);
              }}>
              {" "}
              <i className="bi bi-search me-2"></i> Buscar
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                (refTxtAnio.current as HTMLInputElement).value = "";
                (refTxtFechaDesde.current as HTMLInputElement).value = "";
                (refTxtFechaHasta.current as HTMLInputElement).value = "";
                setValComboTA(null);
                filter(filtersState);
              }}>
              {" "}
              <i className="bi bi-trash me-2"></i>Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="" id="collapseGeneradas">
        <AdminLista
          hideAdd={true}
          hideExport={!isHistorico}
          data={listItems}
          callback={() => {}}
          reload={filter}
          filter={filter}
          exportar={async () => {
            let filters: Partial<IAuditoria> = {};

            filters.VICEPRESIDENCIA = filters.ID_VICEPRESIDENCIA?.toString() || null;
            filters.ANIO = refTxtAnio.current?.value || null;
            filters.FECHA_DESDE = refTxtFechaDesde.current?.value ? new Date(refTxtFechaDesde.current.value) : null;
            filters.FECHA_HASTA = refTxtFechaHasta.current?.value ? new Date(refTxtFechaHasta.current.value) : null;
            filters.TIPO_AUDITORIA = refComboTA?.label;
            setIsDownloading(true);
            await AuditoriaService.ExportExcelHistorico(token, filters);
            setIsDownloading(false);
          }}
          pagination={{
            pages: pages,
            page: page,
            paging: paging,
          }}
          tipo="Programaciones"
          columnsDef={columnsDef}
          isLoading={isLoading}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filter(filters, false, pageSize);
          }}
        />
      </div>
      <DetalleAuditoria auditoriaSeleccionada={planSeleccionado} show={showDetails} callbackClose={closeDetailsPanel} token={token} />
    </div>
  );
}
